import { theme } from "../../theme";
import {
  MissionsContentWrapper,
  MissionCardsContainer,
  MissionRedacted,
  MissionRedactedBackground
} from "./MissionsContent.styled";
import MissionCard from "./MissionCard";
import EncryptedBlock, { generateEncryptedText } from "./EncryptedBlock";
import Mission01TimeToEat from "./Mission01TimeToEat";
import MissionsBanner from "./MissionsBanner/index";

export default function MissionsContent() {
  return (
    <MissionsContentWrapper style={{}}>
      <MissionsBanner
        title="Missions"
        subtitle="Complete quests, unlock gear"
      />

      <MissionCardsContainer>
        {/* Mission 1: Time to Eat */}
        <Mission01TimeToEat />

        {/* Mission 2: Encrypted mission */}
        <MissionCard
          title={`[REDACTED]`}
          num="02"
          primaryColor={theme.baseGreen}
        >
          <EncryptedBlock length={150} />
          <EncryptedBlock length={90} />
          <MissionRedactedBackground>
            <MissionRedacted>[REDACTED]</MissionRedacted>
          </MissionRedactedBackground>
        </MissionCard>

        {/* Mission 3: Encrypted mission */}
        <MissionCard
          title={`[REDACTED]`}
          num="03"
          primaryColor={theme.baseViolet}
        >
          <EncryptedBlock length={80} />
          <EncryptedBlock length={160} />
          <MissionRedactedBackground>
            <MissionRedacted>[REDACTED]</MissionRedacted>
          </MissionRedactedBackground>
        </MissionCard>
      </MissionCardsContainer>
    </MissionsContentWrapper>
  );
}
